module.exports = __webpack_public_path__ + "img/vectorworks_2014.f90fee3c.jpg";